import moment from 'moment-timezone'
import { useCallback, useMemo } from 'react'

export const useGetDates = () => {
  const formatDate = useMemo(() => 'YYYY-MM-DD', [])

  const handleGetLastStartWeekDay = useCallback(() => {
    return moment().subtract(1, 'weeks').startOf('week').format(formatDate)
  }, [formatDate])

  const handleGetLastEndWeekDay = useCallback(() => {
    return moment().subtract(1, 'weeks').endOf('week').format(formatDate)
  }, [formatDate])

  const handleYesterday = useCallback(() => {
    return moment().subtract(1, 'days').format(formatDate)
  }, [formatDate])

  const handleCurrentDay = useCallback(() => {
    return moment().format(formatDate)
  }, [formatDate])

  const handleCurrentWeek = useCallback(() => {
    const firstDayOfWeek = moment().startOf('isoWeek')
    const firstWeekDay = firstDayOfWeek.format(formatDate)

    return firstWeekDay
  }, [formatDate])

  const handleDayOfWeek = useCallback(
    (dayOfWeek: number, lastWeek: boolean) => {
      if (lastWeek) {
        return moment().day(dayOfWeek).subtract(1, 'week').format(formatDate)
      }
      return moment().day(dayOfWeek).format(formatDate)
    },
    [formatDate],
  )

  const handleCurrentMonth = useCallback(() => {
    const day = moment().startOf('month')
    const firstDayOfMonth = day.format(formatDate)

    return firstDayOfMonth
  }, [formatDate])

  const handleNextMonth = useCallback(() => {
    const day = moment().startOf('month').add(1, 'month')
    const firstDayOfMonth = day.format(formatDate)

    return firstDayOfMonth
  }, [formatDate])

  return {
    yesterday: handleYesterday(),
    day: handleCurrentDay(),
    week: handleCurrentWeek(),
    month: handleCurrentMonth(),
    nextMonth: handleNextMonth(),
    lastStartWeekDay: handleGetLastStartWeekDay(),
    lastEndWeekDay: handleGetLastEndWeekDay(),
    formatDate,
    handleDayOfWeek,
  }
}
